import { useMemo, useState } from 'react'
import { azul, vermelho, violeta } from '../../../../../../assets/js/colors'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  ASSOCIATE_DELIVERIES: 'Adicionando entregas para associar',
}

const INITIAL_CUSTOMER = {
  id: 0,
  nomeFantasia: '',
  latitude: 0,
  longitude: 0,
  deliveries: [
    {
      id: 0,
      identifier: '',
      qte_sku: 0,
      weight: 0.0,
      client_id: 0,
      selected: false,
    },
  ],
}

const INITIAL_STATE = {
  markerSVG: {},
  showModal: false,
  customers: [{ ...INITIAL_CUSTOMER }],
  selectedCustomer: {},
  deliveriesToAssociate: [],
  isLoading: true,
  firstRenderComplete: false,
  canOpenMarker: false,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useRoteirizacaoMapa() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      changeLoadStatus(hasLoaded, origin = null) {
        setState(prevState => {
          if (!prevState.firstRenderComplete) prevState.isLoading = !hasLoaded
          prevState.firstRenderComplete = !prevState.isLoading && !origin ? true : false
          return { ...prevState }
        })
      },

      canOpenMarker(selectedVeiculo) {
        setState(prevState => ({ ...prevState, canOpenMarker: selectedVeiculo ? true : false }))
      },

      //Events
      onMarkerClicked(customerId, marker) {
        setState(prevState => {
          if (prevState.canOpenMarker) {
            prevState.showModal = true
            prevState.selectedCustomer = prevState.customers.find(
              customer => customer.id === customerId,
            )
            prevState.markerSVG = marker
          } else prevState.errorMessage = 'Selecione um veiculo para associar as entregas'
          return { ...prevState }
        })
      },

      onModalClose() {
        setState(prevState => ({ ...prevState, showModal: false }))
      },

      onModalSave(customerUpdated) {
        setState(prevState => {
          prevState.showModal = false
          const allSelected = prevState.selectedCustomer.deliveries.every(
            delivery => delivery.selected,
          )
          if (!allSelected) {
            const someSelected =
              prevState.selectedCustomer.deliveries.filter(delivery => delivery.selected).length > 0
            prevState.markerSVG.style.fill = someSelected ? violeta : azul
          } else prevState.markerSVG.style.fill = vermelho
          const index = prevState.customers.findIndex(
            customer => customer.id === customerUpdated.id,
          )
          if (index !== -1) prevState.customers[index] = customerUpdated
          prevState.loadingMessage = LOAD_MESSAGE.ASSOCIATE_DELIVERIES
          return { ...prevState }
        })
      },

      onInit(customers) {
        setState(prevState => ({ ...prevState, customers: customers }))
      },
    }
  }, [])

  return { state, localDispatch }
}
